import { NavLink as RouterNavLink, NavLinkProps as RouterNavLinkProps } from "react-router-dom";
import { Link, LinkProps } from "@mui/material";

type NavLinkProps = LinkProps &
  RouterNavLinkProps & {
    to: string;
  };

/**
 * A MUI Link that uses react-router's NavLink for navigation.
 */
export const NavLink = ({ ...rest }: NavLinkProps): JSX.Element => {
  return <Link component={RouterNavLink} {...rest} />;
};
